const state = {
  id: null,
  description: '',
  tags: [],
  sort: null,
  displayName: '',
}

export default state
